import { store } from "../store/index";
import {
  filterSession,
  get,
  createSession,
  update,
  complete,
  removeSession,
  generateAttendanceDocument,
  listSessionToExport,
} from "../store/actions/SessionActions";

/**
 * Create Session
 */
export const addSession = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createSession(objSend));
  if (result?.payload?.session?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Get Session
 */
export const getSession = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(get(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Session
 */
export const updateSession = async (values, uuid) => {
  const objSend = { ...values };
  const result = await store.dispatch(update(objSend, uuid));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List Session
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterSession(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete Session
 */
export const deleteSession = async (uuid) => {
  const result = await store.dispatch(removeSession([uuid]));
  if (result?.payload) {
    return result.payload;
  }
  return null;
};

export const completeSession = async (uuid, data) => {
  const result = await store.dispatch(complete(uuid, data));
  if (result?.type) {
    return "OK";
  }
  return null;
};

export const generateDocument = async (uuid) => {
  const result = await store.dispatch(generateAttendanceDocument(uuid));
  if (result.payload) {
    return result.payload;
  }
  return null;
};

export const listToExport = async (filter) => {
  const result = await store.dispatch(listSessionToExport(filter));
  if (result && result.payload && result.payload) {
    return result.payload;
  }
  return null;
};
